<template>
</template>

<script>
</script>
<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="special">
					<dl>
						<dd v-for="(item,index) in specialList" :key="index" @click="toList(item)">
							<div class="imgbox_a imgbox_hover">
								<img :src="icoURL+'storage/'+item.image" alt="">
							</div>
						</dd>
					</dl>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'special',
		data(){
			return{
				specialList:[]
			}
		},
		methods: {
			//请求专题专栏
			res_special(e){
				this.axios.get('/api/menus/parentNumber?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.workMenu = response.data.reslut;
							console.log('157',response.data.reslut)
							this.specialList = response.data.reslut
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//跳转列表页
			toList(item){
				console.log("toList",item);
				console.log("toList_route",this.$route);
				this.$router.push({
					path:'/slider/'+ item.parent_id +'/elist??category_id='+item.category_id,
					query:{
						category_id:item.id
					}
				})
			}
		},
		created(){
			// console.log("special",this.$route);
			this.res_special(this.$route.query.category_id)
		},
		mounted(){
		
		}
	}
</script>

<style>
</style>
<style>
</style>